<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
    
   export default {
      page: {
         title: "Add Patient",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         const previous_date = moment().subtract(1, 'days').format("YYYY-MM-DD");
         return {
            title: "Add Patient",
            items: [
               {
                  text: "Patients",
                  href: "/patients",
               },
               {
                  text: "Add Patient",
                  active: true,
               },        
            ],

            patient: {
               country_code_id: 1,
               gender: "",
               name: "",
               mobile: "",
               email: "",
               dob: "",
               address: "",
               pincode: "",
               password: "123456",
               // password_confirmation: "",
               image: "",
               age_type: "1",
               age: "",
               state:"Kerala",
            },

            countries: [],
            states: [],
            add:0,

            token: "",
            errors: {},

            // image: "",
            // preview_image: "",

            today: current_date,
            yesterday: previous_date,
            loading: false,

         };
      },
      mounted() {
         this.fetchCountryCodes();
         this.fetchStates();
      },

      methods: {
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },

         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },

         
         fetchStates() {
            let url = "api/getStates";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.states = responseData;
               })
               .catch((err) => console.log(err));
         },

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         addPatient() {
            this.getToken();
            this.loading = true;
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/addPatient";             
       
            let formData = new FormData();
            formData.append("name", this.patient.name); 
            formData.append("mobile", this.patient.mobile); 
            formData.append("country_code", this.patient.country_code_id); 
            formData.append("email", this.patient.email); 
            formData.append("age_type", this.patient.age_type); 
            formData.append("age", this.patient.age); 
            formData.append("dob", this.patient.dob); 
            formData.append("gender", this.patient.gender);             
            formData.append("address", this.patient.address);
            formData.append("state", this.patient.state); 
            formData.append("pincode", this.patient.pincode); 
            formData.append("password", this.patient.password); 
            // formData.append("password_confirmation", this.patient.password_confirmation); 
            
           
            // formData.append("image", this.image); 
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  console.log(response);
                  this.clearForm();
                  this.patient_id = response.data.data.patient_id;
                  this.patient_name = response.data.data.patient_name;
                  console.log(this.patient_id);
                  console.log(this.add);
                  if(this.add==0){
                     this.$router.push({ name: 'patients'});
                  }else{
                     this.$router.push({ name: 'consultations.add', params: {patient_id:this.patient_id,name:this.patient_name}});
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         clearForm() {           

            this.patient.country_code = 1;
            this.patient.gender = "";
            this.patient.name = "";
            this.patient.mobile = "";
            this.patient.email = "";
            this.patient.dob = "";
            this.patient.address = "";
            this.patient.pincode = "";
            this.patient.password = "";
            this.patient.password_confirmation = "";
            this.patient.image = "";

            this.image = "";
            this.preview_image = "";
            this.errors = {};
         }

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                   <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'patients' }" class="btn btn-primary float-end ms-2">
                           <i class='bx bx-chevrons-left'></i> Back
                           </router-link>

                           <router-link :to="{ name: 'consultations.add' }" class="btn btn-primary float-end">
                           Add Consultation
                           </router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="addPatient()">
                        <div class="row"> 

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="patient.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }" @keypress="alphaSpacesOnly"></b-form-input>

                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Mobile <span class="text-danger">*</span></label>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="patient.country_code_id">
                                       <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                                 <b-form-input v-model="patient.mobile" @keypress="numbersOnly" maxlength="15" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                 <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Email</label>
                              <b-form-input type="email" v-model="patient.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }" autocomplete="off"></b-form-input>

                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                             <b-form-group class="col-lg-4 mb-3" v-if="patient.age_type == 1">
                           <label>
                              Age <span class="text-danger">*</span>
                              <span class="ml-2">
                                 <a href="#" @click.prevent="patient.age_type = 2">Enter DOB Instead</a>
                              </span>
                           </label>

                           <b-form-input
                              type="number"
                              v-model="patient.age"
                              min="1"
                              class="form-control"
                              :class="{ 'is-invalid': Boolean(errors.age) }"
                           ></b-form-input>

                           <div v-for="(val, index) in errors.age" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-form-group>

                           <div class="form-group col-md-4" v-if="patient.age_type == 2">
                              <label>
                                 Date of Birth <span class="text-danger">*</span>
                                 <span class="ml-2">
                                    <a href="#" @click.prevent="patient.age_type = 1">Enter Age Instead</a>
                                 </span>
                              </label>                              
                              <input type="date" v-model="patient.dob" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.dob) }" :max="yesterday"/>

                              <div v-for="(val, index) in errors.dob" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>

                           <b-form-group class="col-lg-4 mb-3">
                              <label>Gender <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="patient.gender" v-bind:class="{ 'is-invalid': Boolean(errors.gender) }">
                                 <option value="">Select</option>
                                 <option value="1">Male</option>
                                 <option value="2">Female</option>
                                 <option value="3">Others</option>
                              </select>

                              <div v-for="(val, index) in errors.gender" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>
                           <b-form-group class="col-lg-4 mb-3">
                              <label>Address <span class="text-danger">*</span></label>
                              <b-form-textarea v-model="patient.address" v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></b-form-textarea>

                              <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>
                           <b-form-group class="col-lg-4 mb-3">
                              <label>State <span class="text-danger">*</span></label>
                               <select class="form-control" v-model="patient.state">
                                 <option :value="state.name" v-for="state in states" :key="state.id">{{state.name}}</option>
                              </select>
                           </b-form-group>
                           <b-form-group class="col-lg-4 mb-3">
                              <label>Pincode </label>
                              <b-form-input v-model="patient.pincode" v-bind:class="{ 'is-invalid': Boolean(errors.pincode) }" @keypress="numbersOnly" maxlength="6"></b-form-input>

                              <div v-for="(val, index) in errors.pincode" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>
                           
                           <b-form-group class="col-lg-4 mb-3">
                              <label>Password <span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="patient.password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>

                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>
                           <!-- <b-form-group class="col-lg-4 mb-3">
                              <label>Confirm Password <span class="text-danger">*</span></label>
                              <b-form-input type="password" ></b-form-input>
                           </b-form-group> -->
                           
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div class="page-loader" v-if="!loading">
                                 <button class="btn btn-primary me-2" type="submit">Save</button>
                                 <button class="btn btn-primary me-2" @click="add = 1" type="submit">Save & Add Consultation</button>
                                 <router-link :to="{ name: 'patients' }" class="btn btn-light">Cancel</router-link>
                              </div>
                              <div class="page-loader" v-else>
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
